import React from "react";
import { TileOptions, TileSetMap } from "../constants";

import "./GameSetup.css";

export class GameSetup extends React.Component {
  constructor(props) {
    super(props);
    this.selRef = React.createRef();
    this.taRef = React.createRef();
    this.state = {
      presetSet: false,
      customSet: false,
    };
  }
  render() {
    return (
      <div className="settings">
        <div className="settings__free-tile">
          <input
            type="checkbox"
            checked={this.props.includeFreeTile}
            onChange={() =>
              this.props.setIncludeFreeTile(!this.props.includeFreeTile)
            }
          ></input>
          <label>Enable Free Tile</label>
        </div>

        <div>
          <h4>Preset Tiles</h4>
          <p>Try these presets!</p>
          <div style={{ display: "flex" }}>
            <select
              ref={this.selRef}
              onChange={() => this.setState({ presetSet: false })}
            >
              {TileOptions.map((o) => (
                <option key={o.value} value={o.value}>{o.display}</option>
              ))}
            </select>
            <button
              onClick={() => {
                this.props.onSubmit(TileSetMap[this.selRef.current.value]);
                this.setState({
                  presetSet: true,
                  customSet: false,
                });
              }}
            >
              Apply
            </button>
            {this.state.presetSet ? <Applied /> : null}
          </div>
        </div>
        <div>
          <h4>Customize Tiles</h4>
          <p>
            Enter words to populate the board, comma-separated or on separate
            lines.
          </p>
          <div className="inputs">
            <textarea
              ref={this.taRef}
              onChange={() => this.setState({ customSet: false })}
            ></textarea>
            <button
              onClick={() => {
                if (this.taRef.current.value.indexOf("\n") > -1) {
                  this.props.onSubmit(this.taRef.current.value.split("\n"));
                } else {
                  this.props.onSubmit(this.taRef.current.value.split(","));
                }
                this.setState({
                  presetSet: false,
                  customSet: true,
                });
              }}
            >
              Apply
            </button>
            {this.state.customSet ? <Applied /> : null}
          </div>
        </div>
      </div>
    );
  }
}

const Applied = () => <span className="settings__applied">Applied!</span>;
